// Rubros duplicados: búsquedas del barrido (/manicuria, /cosmiatra…) y subcategorías de Ágora (/unas,
// /podologia…) que muestran los MISMOS negocios de Ágora (misma subcategoría, mismo orden) y eran
// páginas autocanónicas, indexables y en el sitemap. Cada grupo tiene una sola página: la que más
// clics + impresiones trae en Search Console (90 días al 3/10/2026, sumando sus provincias, ciudades y
// tipos de servicio). Las otras redirigen (308) con todo lo que cuelga de ellas
// (lib/seo/market-redirects.js). Espejo de `src/services/directory-hubs.ts` de cyclone (sitemap,
// /directory/categories, miga de pan de las fichas): si cambia acá, cambia allá.
export const CATEGORY_HUB_ALIASES = Object.freeze({
  // Uñas (subcategoría 390): /unas 335 clics / 30.313 impresiones; /manicuria 13 / 4.080; /manicura
  // 13 / 2.946; /manicurista 8 / 944.
  manicuria: 'unas',
  manicura: 'unas',
  manicurista: 'unas',
  // Podología (490): /podologo 373 / 23.747; /centro-podologico 96 / 6.809; /podologia 47 / 2.702;
  // /centro-para-el-cuidado-de-los-pies 0 / 11. Los tipos de servicio pasan a /podologo/{tipo}.
  podologia: 'podologo',
  'centro-podologico': 'podologo',
  'centro-para-el-cuidado-de-los-pies': 'podologo',
  // Tratamientos faciales (336): 437 / 18.667; /cosmiatra 31 / 1.778; /cosmiatria 14 / 655.
  cosmiatra: 'tratamientos-faciales',
  cosmiatria: 'tratamientos-faciales',
  // Pestañas (394): 131 / 8.092; /salon-de-pestanas 18 / 1.456.
  'salon-de-pestanas': 'pestanas',
  // Cejas (379): 98 / 8.985; /bar-de-cejas 0 / 69.
  'bar-de-cejas': 'cejas',
  // Depilación (356): 273 / 15.475; /centro-de-depilacion 15 / 2.436.
  'centro-de-depilacion': 'depilacion',
  // Maquillaje (338): 49 / 4.070; /maquilladora 35 / 3.585.
  maquilladora: 'maquillaje',
  // Micropigmentación (524): 3 / 105; /clinica-de-maquillaje-permanente 1 / 65.
  'clinica-de-maquillaje-permanente': 'micropigmentacion'
});

/** Slug de la página que queda de un rubro (el mismo si no es un duplicado). */
export const canonicalCategorySlug = (slug) => CATEGORY_HUB_ALIASES[slug] || slug;

/**
 * La lista de rubros de `/directory/categories` sin los duplicados (footer, cruces, /directorio): un
 * rubro duplicado nunca se enlaza, porque su página redirige.
 */
export const withoutDuplicateCategories = (categories = []) =>
  categories.filter((c) => !c?.slug || canonicalCategorySlug(c.slug) === c.slug);

// Primer segmento de rutas que no son listados de app/[category].
export const NON_CATEGORY_ROOTS = Object.freeze(
  new Set([
    'negocios',
    'perfil',
    'servicios',
    'signin',
    'signup',
    'callback',
    'logout',
    'onboarding',
    'indice-de-precios',
    'directorio',
    'api',
    'checkout'
  ])
);
